/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BorrowerProcessStepDto
 */
export interface BorrowerProcessStepDto {
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerProcessStepDto
     */
    isGenerating?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerProcessStepDto
     */
    isSend: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerProcessStepDto
     */
    isSign: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerProcessStepDto
     */
    isReceived?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof BorrowerProcessStepDto
     */
    sendDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BorrowerProcessStepDto
     */
    signDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BorrowerProcessStepDto
     */
    generationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof BorrowerProcessStepDto
     */
    receivedDate?: Date;
}

/**
 * Check if a given object implements the BorrowerProcessStepDto interface.
 */
export function instanceOfBorrowerProcessStepDto(value: object): value is BorrowerProcessStepDto {
    if (!('isSend' in value) || value['isSend'] === undefined) return false;
    if (!('isSign' in value) || value['isSign'] === undefined) return false;
    return true;
}

export function BorrowerProcessStepDtoFromJSON(json: any): BorrowerProcessStepDto {
    return BorrowerProcessStepDtoFromJSONTyped(json, false);
}

export function BorrowerProcessStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerProcessStepDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isGenerating': json['isGenerating'] == null ? undefined : json['isGenerating'],
        'isSend': json['isSend'],
        'isSign': json['isSign'],
        'isReceived': json['isReceived'] == null ? undefined : json['isReceived'],
        'sendDate': json['sendDate'] == null ? undefined : (new Date(json['sendDate'])),
        'signDate': json['signDate'] == null ? undefined : (new Date(json['signDate'])),
        'generationDate': json['generationDate'] == null ? undefined : (new Date(json['generationDate'])),
        'receivedDate': json['receivedDate'] == null ? undefined : (new Date(json['receivedDate'])),
    };
}

export function BorrowerProcessStepDtoToJSON(json: any): BorrowerProcessStepDto {
    return BorrowerProcessStepDtoToJSONTyped(json, false);
}

export function BorrowerProcessStepDtoToJSONTyped(value?: BorrowerProcessStepDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isGenerating': value['isGenerating'],
        'isSend': value['isSend'],
        'isSign': value['isSign'],
        'isReceived': value['isReceived'],
        'sendDate': value['sendDate'] == null ? undefined : ((value['sendDate']).toISOString().substring(0,10)),
        'signDate': value['signDate'] == null ? undefined : ((value['signDate']).toISOString().substring(0,10)),
        'generationDate': value['generationDate'] == null ? undefined : ((value['generationDate']).toISOString().substring(0,10)),
        'receivedDate': value['receivedDate'] == null ? undefined : ((value['receivedDate']).toISOString().substring(0,10)),
    };
}

